import React, { Dispatch, SetStateAction } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import ReviewCard from '@/modules/periodicTasks/components/Create/Steps/Review/ReviewCard';
import { useCreateTechnicalOperationUtils } from '@/modules/workingDay/components/CreateTechnicalOperation/logic';
import { IWorkingDay } from '@/modules/workingDay/types';
import IconWithTitleDescription from '@/shared/components/atoms/IconWithTItleDescription';

const Review: React.FC<{ setStep: Dispatch<SetStateAction<number>> }> = ({
  setStep,
}) => {
  const { t } = useTranslation();
  const { getGeneralCardItems } = useCreateTechnicalOperationUtils();
  const { getValues } =
    useFormContext<IWorkingDay.IOperationFormValuesSchema>();
  const formValues = getValues();

  const sharedCardProps = {
    titleTypography: {
      variant: 'caption' as const,
    },
    descriptionTypography: {
      weight: 'medium' as const,
    },
    iconGap: 'gap-16',
  };

  return (
    // TODO: Review card should be in atoms
    <ReviewCard
      header={t('operation-details')}
      onClick={() => setStep(0)}
      px='px-24'
      py='py-16'
      cols='grid-cols-2'
    >
      {getGeneralCardItems(formValues).map((item) => (
        <IconWithTitleDescription
          key={item.title}
          item={{ ...item, ...sharedCardProps }}
        />
      ))}
    </ReviewCard>
  );
};
export { Review };
